import { VALID } from 'common/const';

const FIELD = {
  address1: {
    label: 'Address 1',
    validation: VALID.ADDRESS.required('Address is required'),
  },
  address2: {
    label: 'Address 2',
    placeholder: 'Village',
    optional: true,
    validation: VALID.ADDRESS_2,
  },
  city: {
    label: 'District',
    validation: VALID.CITY.required('District is required'),
  },
};

export default FIELD;
